/**
 * @generated SignedSource<<0e674f658e2fb0137e149323e5962370>>
 * @relayHash 1deb9c8ea365435c0e98f4b4a2762b85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 43a2b7351e5761bb6b7869099ea331b4220fd39838fe1b2b9a8ea96d25c7fb83

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AppSelectorQuery$variables = Record<PropertyKey, never>;
export type AppSelectorQuery$data = {
  readonly me: {
    readonly user: {
      readonly accountId: string;
      readonly " $fragmentSpreads": FragmentRefs<"AppSelector_userDataFragment" | "StudioFoundationsApp_AtlassianStudioFoundations_userDataFragment">;
    };
  };
  readonly notifications: {
    readonly " $fragmentSpreads": FragmentRefs<"StudioFoundationsApp_AtlassianStudioFoundations_notificationDataFragment">;
  } | null | undefined;
};
export type AppSelectorQuery = {
  response: AppSelectorQuery$data;
  variables: AppSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "accountId"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AppSelectorQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v0/*: any*/),
                  "action": "THROW",
                  "path": "me.user.accountId"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "AppSelector_userDataFragment"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "StudioFoundationsApp_AtlassianStudioFoundations_userDataFragment"
                }
              ]
            },
            "action": "THROW",
            "path": "me.user"
          }
        ]
      },
      {
        "concreteType": "InfluentsNotificationQuery",
        "kind": "LinkedField",
        "name": "notifications",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "StudioFoundationsApp_AtlassianStudioFoundations_notificationDataFragment"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AppSelectorQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v0/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isUser"
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "picture"
              },
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "email"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "locale"
                  }
                ],
                "type": "AtlassianAccountUser"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "InfluentsNotificationQuery",
        "kind": "LinkedField",
        "name": "notifications",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "unseenNotificationCount"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "43a2b7351e5761bb6b7869099ea331b4220fd39838fe1b2b9a8ea96d25c7fb83",
    "metadata": {},
    "name": "AppSelectorQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "677d8755f796192524d92c2de849ffff";

export default node;
